<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{$t('autoAssignConfig')|capitalize}}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-switch v-model="enableAutoAssign" v-on:change="updateAutoAssignConfig">
                                    <template v-slot:label>
                                        <div>{{$t('autoAssign')|capitalize}}: <strong
                                                :class="enableAutoAssign?'success--text':'error--text'">{{$t(enableAutoAssign?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>

                                <div style="display: flex" v-if="hasAdminRole">
                                    <v-text-field id="max-supporting-input"
                                                  class="form-control pt-0 mt-0 px-2"
                                                  v-model="botConfig['maxSupporting']"
                                                  mask="###############"
                                                  v-on:change="update_max_supporting"
                                                  :label="$t('maxSupportingNumber')">

                                        <template v-slot:append-outer>
                                            <v-icon color="#0052CC" :disabled="botConfig['maxSupporting'] == '0'"
                                                    v-on:click="clear_max_supporting"
                                                    style="cursor: pointer">mdi-close</v-icon>
                                        </template>
                                    </v-text-field>
                                </div>
                                <v-switch v-model="botConfig['autoAssignWaitingRequest']"
                                          v-show="botConfig['maxSupporting'] != '0'" class="ma-0"
                                          v-on:change="update_auto_assign_waiting_request">
                                    <template v-slot:label>
                                        <div>{{$t('autoAssignWaitingRequest')|capitalize}}: <strong
                                            :class="botConfig['autoAssignWaitingRequest']?'success--text':'error--text'">{{$t(botConfig['autoAssignWaitingRequest']?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                            </v-flex>
                            <v-divider class="mb-2"></v-divider>
                            <v-tabs v-model="tab">
                                <v-tab v-for="item in tabItems" :key="item.id" style="text-transform: none">
                                    <v-icon class="mr-2">{{item.icon}}</v-icon>
                                    {{$t(item.i18n)}}
                                </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">
                                <v-tab-item v-for="item in tabItems" :key="item.id">
                                    <v-card flat>
                                        <v-card-text v-if="item.i18n==='customizeConfig'">
                                            <v-flex class="d-inline">
                                                <div class="search-customer px-2">
                                                    <v-text-field
                                                            v-model="search"
                                                            type="text"
                                                            clearable
                                                            :label="$t('enterNameOrEmail')"
                                                            append-outer-icon="mdi-magnify"
                                                    ></v-text-field>
                                                </div>
                                            </v-flex>
                                            <v-flex>
                                                <v-data-table
                                                        :items="supporters"
                                                        :search="search"
                                                        :custom-filter="custom_filter"
                                                        hide-headers
                                                        hide-footers
                                                        class="setting-table"
                                                >
                                                    <template v-slot:items="row">
                                                        <div class="mt-1 mb-1 px-2">
                                                            <div class="staff-item" style="cursor: default">
                                                                <v-layout align-center>
                                                                    <div class="mr-3 user-icon">
                                                                        <img v-if="row.item.image" :src="row.item.image" alt="icon"
                                                                             class="staff-image">
                                                                        <div v-else class="staff-icon"
                                                                             :class="(row.item.auto_assign_config && row.item.auto_assign_config.active) ? 'online' : 'offline'">
                                                                            {{$AppService.createTextImage(row.item.name ? row.item.name : row.item.email.split('@')[0])}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="staff-name-wrapper mr-3">
                                                                        <span class="staff-name">{{row.item.name ? row.item.name : row.item.email.split('@')[0]}}</span><br>
                                                                        <span class="staff-email">{{row.item.email}}</span><br>
                                                                    </div>
                                                                    <div class="mr-3 toggle-setting">
                                                                        <v-switch v-model="row.item.auto_assign_config.active"
                                                                                  v-on:change="updateStaffAutoAssignStatus(row.item)">
                                                                            <template v-slot:label>
                                                                                <div>
                                                                                    <strong :class="row.item.auto_assign_config.active?'success--text':'error--text'">
                                                                                        {{$t(row.item.auto_assign_config.active?'on':'off')|capitalize}}
                                                                                    </strong>
                                                                                </div>
                                                                            </template>
                                                                        </v-switch>
                                                                    </div>
                                                                </v-layout>
                                                            </div>
                                                            <div>
                                                                <v-autocomplete
                                                                        v-model="row.item.auto_assign_config.request_support_categories"
                                                                        :items="rsCategories"
                                                                        item-text="name"
                                                                        item-value="id"
                                                                        outlined
                                                                        chips
                                                                        small-chips
                                                                        deletable-chips
                                                                        :label="$t('requestSupportCategories')"
                                                                        multiple
                                                                        @change="updateStaffAutoAssignCategory(row.item)"
                                                                >
                                                                </v-autocomplete>
                                                                <v-switch v-model="row.item.auto_assign_config.can_handle_other_skill"
                                                                          v-on:change="updateStaffAutoAssignCanHandleOtherSkill(row.item)"
                                                                          :false-value="false" :true-value="true">
                                                                    <template v-slot:label>
                                                                        <div>
                                                                            {{ $t('canHandleAllSkill')|capitalize }}: <strong
                                                                                :class="row.item.auto_assign_config.can_handle_other_skill===true?'success--text':'error--text'">{{$t(row.item.auto_assign_config.can_handle_other_skill===true?'on':'off')|capitalize}}</strong>
                                                                        </div>
                                                                    </template>
                                                                </v-switch>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-card-text>
                                        <v-card-text v-if="item.i18n==='quickConfig'">
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-combobox
                                                            v-model="selectedSkill"
                                                            :items="rsCategories"
                                                            :label="$t('requestSupportCategories')|capitalize"
                                                            item-text="name"
                                                            item-value="id"
                                                            multiple
                                                            chips
                                                            @change="onChangeSkill"
                                                            :search-input.sync="searchInputSkill"
                                                    >
                                                        <template v-slot:selection="data">
                                                            <v-chip
                                                                    :key="JSON.stringify(data.item.id)"
                                                                    :selected="data.selected"
                                                                    :disabled="data.disabled"
                                                                    class="v-chip--select-multi"
                                                                    @input="data.parent.selectItem(data.item.id)"
                                                            >
                                                                <v-avatar
                                                                        class="accent white--text"
                                                                        v-text="data.item.name.slice(0, 1).toUpperCase()"
                                                                ></v-avatar>
                                                                {{ data.item.name }}
                                                            </v-chip>
                                                        </template>
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-combobox
                                                            v-model="selectedSupporter"
                                                            :items="supporters"
                                                            :label="$t('supporter')|capitalize"
                                                            item-text="email"
                                                            item-value="id"
                                                            multiple
                                                            chips
                                                            :search-input.sync="searchInputSupporter"
                                                            @change="onChangeSupporter"
                                                    >
                                                        <template v-slot:selection="data">
                                                            <v-chip
                                                                    :key="JSON.stringify(data.item.id)"
                                                                    :selected="data.selected"
                                                                    :disabled="data.disabled"
                                                                    class="v-chip--select-multi"
                                                                    @input="data.parent.selectItem(data.item.id)"
                                                            >
                                                                <span v-if="data.item.name">
                                                                    <v-avatar
                                                                            class="accent white--text"
                                                                            v-text="data.item.name.slice(0, 1).toUpperCase()"
                                                                    ></v-avatar>
                                                                {{ data.item.name }}
                                                                </span>
                                                                <span v-else>
                                                                    <v-avatar
                                                                            class="accent white--text"
                                                                            v-text="data.item.email.slice(0, 1).toUpperCase()"
                                                                    ></v-avatar>
                                                                {{ data.item.email }}
                                                                </span>
                                                            </v-chip>
                                                        </template>
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <div class="text-xs-right">
                                                        <v-btn color="#4977EE" class="add-custom-info" @click="updateAutoAssignConfigMultipleSuppoter">
                                                            {{$t('update')|capitalize}}
                                                        </v-btn>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <div class="chat_view_loading" v-if="loadingDialog">
                <div class="loading_overlay"></div>
                <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
            </div>
        </v-card>
    </v-container>

</template>

<script>
import BotService from '@/services/bot.service'
import {mapMutations, mapState} from "vuex";
import StaffService from "../../services/staff.service";

export default {
        name: "AutoAssignConfig",
        props: {
            botCode: String,
        },
        data() {
            return {
                loadingDialog: false,
                enableAutoAssign: false,
                rsCategories: [],
                supporters: [],
                headers: [
                    {text: '', value: ''},
                ],
                search: "",
                hasAdminRole: false,
                tab: null,
                tabItems: [{id: 1, i18n: 'customizeConfig', icon: 'mdi-settings'}, {id: 2, i18n: 'quickConfig', icon: 'mdi-flash'}],
                selectedSkill: [],
                selectedSupporter: [],
                searchInputSupporter: '',
                searchInputSkill: ''
            }
        },
        computed: {
            ...mapState('config', ['botConfig']),
            ...mapState(['user']),
        },
        mounted() {
            if (this.botCode) {
                this.loadAutoAssignConfig();
            }
        },
        methods: {
            ...mapMutations('config', ['setBotConfig']),
            onChangeSupporter(val) {
                this.searchInputSupporter = ''
                this.selectedSupporter = val.filter(item => typeof item === "object")
            },
            onChangeSkill(val) {
                this.searchInputSkill = ''
                this.selectedSkill = val.filter(item => typeof item === "object")
            },
            changeBot(bot) {
                this.$router.push('/auto-assign-config/' + bot.code)
            },
            updateAutoAssignConfigMultipleSuppoter() {
                this.loadingDialog = true;
                const usersId = this.selectedSupporter.map(o => o.id)
                const categories = this.selectedSkill.map(o => o.id)
                BotService.updateAutoAssignConfigMultipleSupporter(this.$route.params.botCode, usersId, categories)
                    .then(()=> {
                        this.$AppService.toastSuccess("update auto assign config success.");
                        this.loadAutoAssignConfig()
                        this.selectedSkill = [];
                        this.selectedSupporter = [];
                    })
                    .catch(()=> {
                        this.$AppService.toastError("update auto assign config failed.");
                    })
                    .finally(()=> {
                        this.loadingDialog = false;
                    })
            },
            loadAutoAssignConfig() {
                this.loadingDialog = true;
                BotService.getAutoAssignStatus_manage(this.$route.params.botCode).then(response => {
                    this.enableAutoAssign = response.data.enable_auto_assign === "1";
                    this.rsCategories = response.data.rs_categories || [];
                    this.supporters = response.data.supporters || [];
                    for (let staff of this.supporters) {
                        staff.auto_assign_config.origin_request_support_categories = staff.auto_assign_config.request_support_categories;
                    }
                }).catch(() => {
                    this.$AppService.toastError("get auto assign config failed.");
                    this.enableAutoAssign = false;
                    this.rsCategories = [];
                    this.supporters = [];
                }).finally(() => {
                    this.hasAdminRole = StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9]);
                    this.loadingDialog = false;
                })

            },
            updateAutoAssignConfig() {
                this.loadingDialog = true;
                let enable_auto_assign = this.enableAutoAssign ? "1" : "0";
                BotService.updateAutoAssignConfig_manage(this.$route.params.botCode, {enable_auto_assign}).then(() => {
                    this.$AppService.toastSuccess("update auto assign config success.");
                }).catch(() => {
                    this.$AppService.toastError("update auto assign config failed.");
                    this.enableAutoAssign = !this.enableAutoAssign;
                }).finally(() => {
                    this.loadingDialog = false;
                })
            },
            updateStaffAutoAssignStatus(staff) {
                this.loadingDialog = true;
                let user_id = staff.id
                let active = staff.auto_assign_config.active;
                BotService.updateAutoAssignSupporterConfig_manage(this.$route.params.botCode, user_id, {active}).then(() => {
                    this.$AppService.toastSuccess("update staff " + (staff.name ? staff.name : staff.email) + " auto assign status success.");
                }).catch(() => {
                    this.$AppService.toastError("update staff " + (staff.name ? staff.name : staff.email) + " auto assign status failed.");
                    staff.auto_assign_config.active = !active;
                }).finally(() => {
                    this.loadingDialog = false;
                })
            },
            updateStaffAutoAssignCategory(staff) {
                let user_id = staff.id
                let categories = staff.auto_assign_config.request_support_categories;
                BotService.updateAutoAssignSupporterConfig_manage(this.$route.params.botCode, user_id, {categories}).then(() => {
                    this.$AppService.toastSuccess("update staff " + (staff.name ? staff.name : staff.email) + " request support skills success.");
                    staff.auto_assign_config.origin_request_support_categories = staff.auto_assign_config.request_support_categories;
                }).catch(() => {
                    this.$AppService.toastError("update staff " + (staff.name ? staff.name : staff.email) + " request support skills failed.");
                    staff.auto_assign_config.request_support_categories = staff.auto_assign_config.origin_request_support_categories;
                })
            },
            updateStaffAutoAssignCanHandleOtherSkill(staff) {
                this.loadingDialog = true;
                let user_id = staff.id
                let can_handle_other_skill = staff.auto_assign_config.can_handle_other_skill;
                BotService.updateAutoAssignSupporterConfig_manage(this.$route.params.botCode, user_id, {can_handle_other_skill}).then(() => {
                    this.$AppService.toastSuccess("update staff " + (staff.name ? staff.name : staff.email) + " auto assign status success.");
                }).catch(() => {
                    this.$AppService.toastError("update staff " + (staff.name ? staff.name : staff.email) + " auto assign status failed.");
                    staff.auto_assign_config.can_handle_other_skill = !can_handle_other_skill;
                }).finally(() => {
                    this.loadingDialog = false;
                })
            },
            custom_filter(items, search) {
                if (!search) return items;
                let result = [];
                for (let staff of items) {
                    if ((staff.name && staff.name.toLowerCase().indexOf(search.toLowerCase()) !== -1)
                        || (staff.email && staff.email.toLowerCase().indexOf(search.toLowerCase()) !== -1)) {
                        result.push(staff)
                    }
                }

                return result;
            },
            update_max_supporting() {
                this.loadingDialog = true;
                this.botConfig['maxSupporting'] = this.botConfig['maxSupporting'].trim() || "0";
                BotService.updateMaxSupportingConfig(this.$route.params.botCode, this.botConfig['maxSupporting']).then(() => {
                    this.$AppService.toastSuccess("update max supporting success.");
                }).catch(() => {
                    this.$AppService.toastError("update max supporting failed.");
                }).finally(() => {
                    this.botConfig['maxSupporting'] = (parseInt(this.botConfig['maxSupporting']) || 0).toString();
                    this.loadingDialog = false;
                })
            },
            clear_max_supporting() {
                this.botConfig['maxSupporting'] = "0";
                this.update_max_supporting();
            },
            update_auto_assign_waiting_request() {
                this.loadingDialog = true;
                let auto_assign_waiting_request = this.botConfig['autoAssignWaitingRequest'] ? "1" : "0";
                BotService.updateAutoAssignConfig_manage(this.$route.params.botCode, {auto_assign_waiting_request}).then(() => {
                    this.$AppService.toastSuccess("update auto assign config success.");
                }).catch(() => {
                    this.$AppService.toastError("update auto assign config failed.");
                    this.botConfig['autoAssignWaitingRequest'] = !this.botConfig['autoAssignWaitingRequest'];
                }).finally(() => {
                    this.loadingDialog = false;
                })
            },
        },
        watch: {
            botCode() {
                if (this.botCode) {
                    this.loadAutoAssignConfig();
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }

    ::v-deep .v-card__title {
        height: 40px;
        background: #0052CC 0% 0% no-repeat padding-box;
        padding: 8px 12px !important;
    }

    ::v-deep .v-card {
        border-radius: 4px !important;
    }

    .headline {
        color: #FFFFFF;
        font-size: 18px !important;
        line-height: 30px;
    }

    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }

    .header-tooltips {
        width: 240px;
        background: #1b3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2a4b64;
        }
    }

    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00afc8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }

    .add-custom-info {
        color: #FFFFFF;
        text-transform: none;
        font-weight: bold;
        border-radius: 5px !important;
        margin-left: 0px !important;
    }
</style>
<style scoped lang="scss" src="../../components/style/staff.scss"></style>
